import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Picks between a backend label and a locale key.
 *
 * The backend sends its labels in Czech only (`label_cs`), which is the customer's language and
 * therefore shown as is. In the English UI the same thing is looked up by its key in the locale
 * files — which is why every backend label travels with a stable key.
 */
export const useBackendLabel = (): ((labelCs: string | undefined, fallbackKey: string) => string) => {
  const { t, i18n } = useTranslation();
  const isCzech = (i18n.language ?? '').startsWith('cs');
  return useCallback(
    (labelCs: string | undefined, fallbackKey: string) => (isCzech && labelCs ? labelCs : t(fallbackKey)),
    [isCzech, t]
  );
};
